import type { DayOfWeek } from "@/lib/types";

export const SELL_FORM_DAYS_OF_WEEK: Array<{
  value: DayOfWeek;
  label: string;
}> = [
  { value: 0, label: "Sunday" },
  { value: 1, label: "Monday" },
  { value: 2, label: "Tuesday" },
  { value: 3, label: "Wednesday" },
  { value: 4, label: "Thursday" },
  { value: 5, label: "Friday" },
  { value: 6, label: "Saturday" },
];

export const SELL_FORM_HOURS_OF_DAY = Array.from(
  { length: 13 },
  (_, i) => i + 8,
).map((hour) => ({
  value: hour,
  label: `${hour > 12 ? hour - 12 : hour}:00 ${hour >= 12 ? "PM" : "AM"}`,
}));

/** Human-readable pickup window from stored hour strings (e.g. "9", "17"). */
export function formatSellFormPickupWindow(
  pickupStartHour: string,
  pickupEndHour: string,
): string {
  const start = SELL_FORM_HOURS_OF_DAY.find(
    (h) => h.value === parseInt(pickupStartHour, 10),
  );
  const end = SELL_FORM_HOURS_OF_DAY.find(
    (h) => h.value === parseInt(pickupEndHour, 10),
  );
  return `${start?.label ?? pickupStartHour} – ${end?.label ?? pickupEndHour}`;
}
